import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { VendorsEffects } from './effects'
import { vendorsReducer } from './reducer'
import { VendorsGuard } from './guard'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('vendors', vendorsReducer),
    EffectsModule.forFeature([VendorsEffects]),
  ],
  declarations: [],
  providers: [VendorsGuard],
  exports: [],
})
export class VendorsStoreModule {}
